import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { selectedInvestmentStateFinance, showModalStateFinance } from '../../state/FinanceUIStateJ';
import { useInvestmentModalActions } from '../../hooks/useFinanceModalActions';
import { GenericFallbacksWrapper } from '../../../../components/Fallback/GenericFallbacksWrapper';
import { DeleteInvestmentModal } from './DeleteInvestmentModal';
import { EditInvestmentModal } from './EditInvestmentModal';
import { LinkAumniModal } from './LinkAumniModal';

export const RoundModals: FC = () => {
  const showModalState = useAtomValue(showModalStateFinance);
  const selectedInvestment = useAtomValue(selectedInvestmentStateFinance);
  const { handleCloseModal } = useInvestmentModalActions();

  if (!selectedInvestment) {
    return null;
  }
  return (
    <GenericFallbacksWrapper>
      <EditInvestmentModal
        open={showModalState === 'editInvestment'}
        onClose={handleCloseModal}
        investment={selectedInvestment}
      />

      <DeleteInvestmentModal
        onClose={handleCloseModal}
        open={showModalState === 'deleteInvestment'}
        investment={selectedInvestment}
      />

      <LinkAumniModal
        open={showModalState === 'linkAumni'}
        onClose={handleCloseModal}
        investment={selectedInvestment}
      />
    </GenericFallbacksWrapper>
  );
};
